import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginRegisterService } from './login-register.service';

@Component({
  selector: 'app-register-login',
  templateUrl: './login-register.component.html',
  styleUrls: ['./login-register.component.scss']
})

export class LoginRegisterComponent implements OnInit {

  constructor(
    private router: Router,
    private loginRegisterService: LoginRegisterService) { }

  ngOnInit() {
    this.loginRegisterService.currentUser.subscribe((res) => {
      if (res) {
        this.router.navigateByUrl('/dashboard/home');
      }
    });
  }

  goCompany() {
    localStorage.setItem('lastLoginChoice', 'company');
    this.router.navigateByUrl('/login/employerLogin');
  }

}
